import * as moment from "moment";
import { showError } from "@/global";


export var AnalysisDataMixin = {
  data() {
    return {
      analysisTimestamp: '',
      optionsDatePicker: {
        locale: moment.locale("pt-br"),
        format: false,
        extraFormats: ["DD/MM/YYYY HH:mm:ss", "YYYY/MM/DD HH:mm:ss", "x"],
        dayViewHeaderFormat: "MMMM/YYYY",
        allowInputToggle: true,
        useCurrent: false,
        showTodayButton: true,
        showClear: true,
        showClose: true,
        sideBySide: true,
        inline: false,
        keepOpen: false,
        tooltips: {
          today: "Hoje",
          clear: "Limpar",
          close: "Fechar",
          selectMonth: "Selecionar mês",
          prevMonth: "Mês anterior",
          nextMonth: "Próximo mês",
          selectYear: "Selecionar ano",
          prevYear: "Ano anterior",
          nextYear: "Próximo ano",
          selectDecade: "Selecionar década",
          prevDecade: "Década anterior",
          nextDecade: "Próxima década",
          prevCentury: "Século anterior",
          nextCentury: "Próximo século",
        },
      },
    };
  },

  methods: {
    formatBaseDate(baseDate) {
      if (typeof baseDate == "object") {
        baseDate = baseDate.format().substring(0, 19);
      } else {
        baseDate = baseDate.split("/").reverse();
        baseDate = baseDate.join("-");
      }
      return baseDate;
    },

    canSave(analysesData) {
      let canSave = false;
      analysesData.forEach((a) => {
        if (a.value && a.value != 0) canSave = true;
      });
      if (!canSave) {
        showError(this.$t('nao-ha-dados-para-serem-salvos'));
      }
      return canSave;
    }
  },

  created() {
    this.analysisTimestamp = moment();
  },
};
